import React, { useEffect, useState } from "react";
//import GridItem from "./grid-item";
import * as httpService from '../../services/HTTPService';
import Placeholder from 'react-bootstrap/Placeholder';
import {Grid} from 'react-virtualized';
import { lazy } from 'react';

const GridItem = lazy(() => import("./grid-item"));

export const PlaceholderHTML = () => {
    return (
        <Placeholder animation="glow">
            <div className="bl-catalog-masonry bl-placeholder">
                {
                    [1,2,3,4,5,6,7,8,9,10].map((_, index) => {
                        return (
                            <div key={index} className="bl-catalog-item">
                                <div className="item-img">
                                    <Placeholder style={{"width": "220px", "height": "220px", "borderRadius": "15px"}} >
                                        
                                    </Placeholder>
                                </div>
                                <div className="item-content">
                                    <Placeholder style={{"borderRadius": "15px"}} >
                                        <h3 className="item-content-type">Ametista</h3>
                                    </Placeholder>
                                    <Placeholder style={{"borderRadius": "15px"}} >
                                        <h4 className="item-content-text inter-bold">Giardini</h4>
                                    </Placeholder>
                                    
                                    <div className="item-content-text"></div>
                                    <Placeholder style={{"borderRadius": "15px"}} >
                                        <span className="">Поръчай Мостра</span>
                                    </Placeholder>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </Placeholder>
    )
}

const GridComponent = (props: any) => {
    let fakeData = [
        {
            name: "наименование на продукта",
            manufacturer: "производител",
            productType: "вид продукт",
            shortDescr: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's",
            imageUrl: "./img/grid/Rectangle11.png",
            linkToProduct: "/product/123",
            id: 1,
            colors: [
                {item: "./img/grid/image2.png"},
                {item: "./img/grid/image2.png"},
                {item: "./img/grid/image2.png"}
            ]
        },
        {
            name: "наименование на продукта",
            manufacturer: "производител",
            productType: "вид продукт",
            shortDescr: "Test search... Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's",
            imageUrl: "./img/grid/Rectangle10.png",
            linkToProduct: "/product/123",
            id: 2,
            colors: [
                {item: "./img/grid/image2.png"},
                {item: "./img/grid/image2.png"},
                {item: "./img/grid/image2.png"}
            ]
        }
    ]; 
    let [filteredData, setFilteredArray] = useState([]);

    let [data, setData] = useState([]);
    let [slicedProducts, setSlicedProducts] = useState([]);
    let [allProducts, setAllProducts] = useState([]);

    const [closeMenu, setCloseMenu] = useState(false);
    const [closeTrigger, setCloseTrigger] = useState(1);

    const populateFakeData = () => {
        let arr: any = props.data ? props.data : [...fakeData];
        if(!props.data) {
            for(var i = 0; i < 45; i++) {
                if(i % 2 === 0) {
                    fakeData[0]['id'] = i;
                    arr.push(fakeData[0]);
                }
                else {
                    fakeData[1]['id'] = i;
                    arr.push(fakeData[1]);
                }
            }
        }
        data = arr;
        setData(arr);
    }

    const getAllProducts = () => {
        let hasResult = false;
        if(hasResult === false && data.length === 0) {
            httpService.getAllProducts().then((res) => {
                //console.log(res);
                data = res.data;
                setData(res.data);
                hasResult = true;
            })
            .catch((err) => console.log(err))
        }
    }

    const handleScroll = () => {
        // const element: any = window;
        let bottom =   Math.ceil(window.innerHeight + window.scrollY) > document.documentElement.scrollHeight - 300;
        //console.log(bottom);
        if(bottom && slicedProducts.length > 0) {
            const doc: any  = document.querySelector('.search-control');
            const inputValue: any = doc ? doc.value : "";
            // prevent loading more products when isSearchPerformed
            if(filteredData.length === 0 ) {
                fetchDataArray(slicedProducts.length, slicedProducts.length + 15);
                bottom = true;
                return bottom;
            }
        }
    }

    const fetchDataArray = (startIndex: any, count: any) => {
        const productsArray = [...data];
        if(startIndex > 0) {
            let slicedArr = [...slicedProducts];
            let newArray = slicedArr.concat(allProducts.slice(startIndex, count));
            slicedProducts = newArray;
            setSlicedProducts(newArray);
            data = newArray;
            setData(newArray);
        }
        else {
            // initial slice
            slicedProducts = productsArray.slice(startIndex, count);
            setSlicedProducts(productsArray.slice(startIndex, count));
        }
    }

    const cellRenderer = (props: any) => {
        if(props.item) {
            const gridItem = props.item;
            return (
                <GridItem   item={gridItem} index={props.rowIndex} key={props.rowIndex}  >
                    {data[props.rowIndex][props.columnIndex]}
                </GridItem>
            );
        }
        return null;
    }

    const reloadItems = () => {
        if(props.reloadItems) {
            props.reloadItems();
        }
    }

    const handleDocumentClick = (e:any) => {
        //console.log(e.target);
        setCloseTrigger(closeTrigger + 1);
        if(e.target.className.indexOf('bl-catalog-masonry') !== -1) {
            setCloseMenu(true);
        }
        else {
            setCloseMenu(false);
        }
    }

    useEffect(() => {
        //populateFakeData();
        if(props.fakeData) {
            populateFakeData();
        }
        // get the real data instead 
       // getAllProducts();
        if(props.products) {
            data = props.products;
            setData(props.products);
        }
        if(props.dataSource) {
            props.dataSource(data);
            //console.log(props.products.length)
        }
    }, [props.products]) 
    
    useEffect(() => {
        if(props.filteredData && props.filteredData.length > 0) {
            allProducts = props.filteredData;
            setAllProducts(props.filteredData);
            setData(props.filteredData.slice(0, 60))
            slicedProducts = props.filteredData.slice(0, 60);
            setSlicedProducts(props.filteredData.slice(0, 60))
        }
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [props.filteredData])

    useEffect(() => {
        document.addEventListener("click", handleDocumentClick);
        return () => {
            document.removeEventListener("click", handleDocumentClick);
        };
    }, [closeTrigger])

    return (
        <div>
            {data.length > 0 ? (
                <div className="bl-catalog">
                    <div className="bl-catalog-masonry">
                        {data.map((item: any, index) => {
                            const d: any = data;
                            return (
                                // <Grid
                                //     cellRenderer={cellRenderer}
                                //     columnCount={5}
                                //     columnWidth={100}
                                //     height={300}
                                //     rowCount={data.length}
                                //     rowHeight={30}
                                //     width={300}
                                // />
                                <GridItem closeMenu={closeMenu} reloadItems={reloadItems} item={item} index={index} key={index} moodBoards={props.moodboards} /> 
                            )
                        })}
                    </div>
                </div>
            ) : null }
        </div>
    )
}

export default GridComponent;